import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import styles from './Search.module.scss';

interface SearchProps {
    className?: string;
    onSearch?: (text: string) => void;
}

export const Search: FunctionComponent<SearchProps> = props => {
    const debounced = useDebouncedCallback(value => {
        props.onSearch?.(value);
    }, 100);

    return (
        <div className={clsx(styles.container, props.className)}>
            <FontAwesomeIcon
                icon={faMagnifyingGlass}
                fontSize={18}
            />
            <input
                onFocus={event => event.target.select()}
                className={styles.input}
                onChange={event => debounced(event.target.value)}
            />
        </div>
    );
};

export default Search;
